import React, { useEffect, useState, useContext } from 'react';
import './Navbar2.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { HomeContext } from '../Context/HomeContext';
import { FaSearch } from 'react-icons/fa';

export default function Navbar2() {
  const [menu, setMenu] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1140); // ✅ Dynamic state
  const navigate = useNavigate();

  const { homeData } = useContext(HomeContext);
  const categories = homeData?.allCategories ? Object.values(homeData.allCategories) : [];

  // ✅ Update isMobile on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1140);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSearch = () => {
    if (!searchTerm.trim()) return;
    navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
    setIsModalOpen(false);
    setSearchTerm('');
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const toggleMenu = () => {
    setMenu(!menu);
    setOpenDropdowns({});
  };

  const toggleDropdown = (slug) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [slug]: !prev[slug],
    }));
  };

  const handleCategoryClick = (cat, e) => {
    if (isMobile && cat.sub_categories && Object.keys(cat.sub_categories).length > 0) {
      if (e.target.classList.contains('dropdown-arrow')) {
        e.stopPropagation();
        toggleDropdown(cat.slug);
      } else {
        navigate(`/category/${cat.slug}`);
        setMenu(false);
        setOpenDropdowns({});
      }
    } else {
      navigate(`/category/${cat.slug}`);
      setMenu(false);
      setOpenDropdowns({});
    }
  };

  const handleSubcategoryClick = (slug, e) => {
    e.stopPropagation();
    navigate(`/subcategory/${slug}`);
    setMenu(false);
    setOpenDropdowns({});
  };

  return (
    <div className='section'>
      <div className='part1'>
        <div className='img1 p-2'>
          <NavLink to={'/'}>
            <img
              src={process.env.PUBLIC_URL + "/logo.png"}
              width="120px"
              height="50px"
              alt="StreamPlay Network"
              
              className="imglogo"
            />
          </NavLink>
        </div>

        <div className='subpart1'>
          <div onClick={toggleMenu}>
            {menu ? <span className='icon1'>&#10005;</span> : <span className='icon2'>&#8801;</span>}
          </div>

          <ul className={menu ? 'lists active' : 'lists'}>
            <li className='navlink2 home'><NavLink to='/' onClick={() => setMenu(false)}>Home</NavLink></li>

            {categories.map(cat => (
              <li
                className="category-menu"
                key={cat.slug}
                onClick={(e) => handleCategoryClick(cat, e)}
              >
                <span className="navlink1">
                  {cat.name}
                  {isMobile && cat.sub_categories && Object.keys(cat.sub_categories).length > 0 && (
                    <span
                      className="dropdown-arrow"
                      style={{ float: 'right', marginRight: '20px' }}
                    >
                      {openDropdowns[cat.slug] ? '▲' : '▼'}
                    </span>
                  )}
                </span>

                {cat.sub_categories && Object.keys(cat.sub_categories).length > 0 && (
                  <ul
                    className={`subcategory-dropdown ${isMobile && openDropdowns[cat.slug] ? 'show' : ''}`}
                  >
                    {Object.values(cat.sub_categories).map(sub => (
                      <li key={sub.slug}>
                        <span
                          onClick={(e) => handleSubcategoryClick(sub.slug, e)}
                          className="dropdown-item"
                        >
                          {sub.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}

            <li className='home'><NavLink to='/AboutUs' onClick={() => setMenu(false)}>About Us</NavLink></li>
            <li className='home'><NavLink to='/ContactUs' onClick={() => setMenu(false)}>Contact Us</NavLink></li>
          </ul>
        </div>

     
      </div>
    </div>
  );
}
